const LAST_RELOAD_KEY = 'arvoke.staleChunkReloadAt'

/** A second failure this soon after a reload is a real outage, not a deploy. */
export const STALE_CHUNK_RELOAD_COOLDOWN_MS = 30_000

/**
 * Whether a failed chunk load should reload the page, recording the attempt.
 * After a deploy, a tab opened on the old build asks for chunks that no longer
 * exist; one reload picks up the new build. A failed lazy import is cached, so
 * nothing short of a reload recovers. Without session storage there is no way
 * to stop a reload loop, so the error page shows instead.
 */
export function claimStaleChunkReload(storage: Storage | null, now: number): boolean {
  if (!storage) return false
  try {
    const lastReloadAt = storage.getItem(LAST_RELOAD_KEY)
    if (lastReloadAt !== null && now - Number(lastReloadAt) < STALE_CHUNK_RELOAD_COOLDOWN_MS) {
      return false
    }
    storage.setItem(LAST_RELOAD_KEY, String(now))
    return true
  } catch {
    return false
  }
}

function getSessionStorage(): Storage | null {
  try {
    return window.sessionStorage
  } catch {
    return null
  }
}

/** Reloads once when Vite reports that a code chunk failed to load. */
export function installStaleChunkReload(): void {
  window.addEventListener('vite:preloadError', () => {
    if (claimStaleChunkReload(getSessionStorage(), Date.now())) {
      window.location.reload()
    }
  })
}
